import "./servicedashboard.css"

import ServiceDashboardComponent from "../../assets/components/07_service_component/service_dashboard_component/service_dashboard_component";
import { HelmetProvider } from 'react-helmet-async';
import Graphic1 from "../../assets/Images/Elements/M-Orange.svg"
import Graphic2 from "../../assets/Images/Elements/Line.svg"

import Header from "../../assets/components/01_header/header"
import Footer from "../../assets/components/02_footer/footer"

export default function ServuceDashboard() {
    return (
        <div>
            <HelmetProvider>
                <title>Premium Digital Marketing Solutions for Businesses in Mumbai</title>
                <meta name="Explore Adstrate, a digital marketing agency in Mumbai offering website design, social media marketing in Mumbai, SEO, Instagram marketing agency services, and content creation." />
                <link rel="canonical" href="https://adstrate.in/services" />
            </HelmetProvider>
            <Header />
            <div className="ServiceDashboard-HeroSection">
                <img src={Graphic1} alt="" />
                <img src={Graphic2} alt="" />
                <h1>
                    Services by a Leading Digital Marketing Agency in <span>Mumbai</span>
                </h1>
                <p>
                    Adstrate is a results-driven digital marketing agency in Mumbai, offering social media marketing, SEO, website development, content creation, and Instagram marketing. Our strategies combine creativity with data-driven insights to boost visibility, engage audiences, and drive measurable growth.
                </p>
            </div>
            <ServiceDashboardComponent />
            <Footer />
        </div>
    );
}